import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-meet-the-assessor',
    templateUrl: './meet-the-assessor.component.html',
    styleUrls: ['./meet-the-assessor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MeetTheAssessorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
